import type { WordStatus } from '@/types/word'

/**
 * Human-readable names for the SRS status of a vocabulary entry.
 *
 * Shared between the vocabulary page's filter controls and the status badge on
 * each row, so it lives here rather than in either of them. Mirrors the
 * `status` values on UserWordSense / CustomFlashcard.
 */
export const STATUS_LABELS: Record<WordStatus, string> = {
  new: 'New', learning: 'Learning', review: 'Review', mastered: 'Mastered',
}
